import { gql } from '@apollo/client';

export const GET_TIKTOK_LOCATION_COUNTRIES = gql`
  query getTikTokLocationCountries {
    tiktokLocationCountries
      @rest(
        type: "TikTokLocationCountries"
        path: "/v4/tiktok-locations/countries"
      ) {
      country_codes
    }
  }
`;
